import { render, staticRenderFns } from "./MousePointer.vue?vue&type=template&id=3cec4dbe"
import script from "./MousePointer.vue?vue&type=script&lang=js"
export * from "./MousePointer.vue?vue&type=script&lang=js"
import style0 from "./MousePointer.vue?vue&type=style&index=0&id=3cec4dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports